<template>
  <div id="sidebar">


    <SidebarOverlay v-model="ui.sidebarOpen" title="TelemetryHub">
      <div class="sb-root">
        <SidebarSection :title="dashboardTitle" icon="monitor" :items="dashboardItems" :collapsible="true"
          :startOpen="dashboardsOpen" :i18n="$i18n" :divider="false" @navigate="onNavigate" />

        <SidebarSection :title="$i18n.t('map')" icon="map" :items="[
          { to: '/Map', labelKey: 'map', icon: 'map' },
          { to: '/MapHistory', labelKey: 'historyPath', icon: 'route' }
        ]" :collapsible="false" :divider="false" @navigate="onNavigate" />

        <SidebarSection :title="$i18n.t('blueprints')" icon="image"
          :items="[{ to: '/blueprint', labelKey: 'blueprints', icon: 'image' }]" :collapsible="false" :divider="false"
          @navigate="onNavigate" />

        <SidebarSection v-if="!isMobile" :title="$i18n.t('accesses')" icon="group" :items="userItems"
          :collapsible="true" :divider="true" @navigate="onNavigate" />

        <SidebarSection v-if="!isMobile" :title="$i18n.t('History')" icon="history" :items="historyItems"
          :collapsible="true" :divider="true" @navigate="onNavigate" />

        <SidebarSection :title="$i18n.t('presentation')" icon="motion_play"
          :items="[{ to: '/presentation', labelKey: 'presentation', icon: 'view_carousel' }]" :collapsible="false"
          :divider="true" @navigate="onNavigate" />

        <SidebarSection v-if="!isMobile" :title="$i18n.t('configuration')" icon="settings" :items="configItems"
          :collapsible="true" :divider="true" @navigate="onNavigate" />

        <SidebarSection v-if="!isMobile" :title="$i18n.t('triggers')" icon="notifications" :items="alarmItems"
          :collapsible="true" :divider="true" @navigate="onNavigate" />

        <SidebarSection v-if="!isMobile" :title="$i18n.t('video')" icon="video_library" :items="videoItems"
          :collapsible="true" :divider="true" @navigate="onNavigate" />


      </div>
    </SidebarOverlay>
  </div>
</template>

<script>
import SidebarOverlay from '@/components/SidebarOverlay.vue';
import SidebarSection from '@/components/SidebarSection.vue';
import { useDashboardStore } from '@/stores/dashboards';
import { useUiStore } from '@/stores/ui';

export default {
  components: { SidebarOverlay, SidebarSection },

  computed: {

    ui() { return useUiStore(); },

    dashboardStore() { return useDashboardStore(); },
    isMobile() { return this.$session.get('isMobile'); },
    isUserSecundary() { return this.$session.get('user').privilege == 2; },

    dashboardTitle() {
      return this.isUserSecundary ? this.$i18n.t('dashboards') : this.$i18n.t('allDashboards');
    },

    dashboardsOpen() { return this.dashboardStore.isOpen; },
    dashboardItems() {
      return this.dashboardStore.sortedRoutes.map(d => ({
        to: d.to,
        icon: 'grid_view',
        label: d.name,
      }));
    },
    userItems() {
      return [
        { to: '/user', labelKey: 'users', icon: 'person', visible: !this.isUserSecundary },
        //{ to: '/aggregation', labelKey: 'aggregation', icon: 'hub', visible: !this.isUserSecundary },
        { to: '/tree', labelKey: 'tree', icon: 'flowchart', visible: !this.isUserSecundary },
      ];
    },

    historyItems() {
      return [
        { to: '/history', labelKey: 'data', icon: 'monitoring' },
        { to: '/HistoryEvents', labelKey: 'events', icon: 'notifications' },
        { to: '/report', labelKey: 'report', icon: 'description' },
        { to: '/audit', labelKey: 'audit', icon: 'fact_check', visible: this.$session.get('privilege') == '0' },
      ];
    },

    configItems() {
      return [
        { to: '/serialNumber', labelKey: 'serialNumbers', icon: 'barcode', visible: this.$session.get('privilege') == 0 },
        { to: '/server', labelKey: 'servers', icon: 'database', visible: this.$session.get('privilege') == 0 },
        { to: '/device', labelKey: 'devices', icon: 'dns', visible: !this.isUserSecundary },
        { to: '/variableCode', labelKey: 'variableCodes', icon: 'reset_settings', visible: !this.isUserSecundary },
        { to: '/variable', labelKey: 'variables', icon: 'planner_review', visible: !this.isUserSecundary },
        { to: '/display', labelKey: 'displays', icon: 'palette', visible: !this.isUserSecundary },
        { to: '/measurer', labelKey: 'measurers', icon: 'swap_driving_apps_wheel', visible: !this.isUserSecundary },
        { to: '/group', labelKey: 'groups', icon: 'dashboard_customize', visible: !this.isUserSecundary },
        { to: '/dashboard', labelKey: 'dashboards', icon: 'grid_view' },
        { to: '/digifort', labelKey: 'digifort', icon: 'join' },
        { to: '/maplayers', labelKey: 'layers-map', icon: 'layers', visible: !this.isUserSecundary },
        { to: '/blueprintlayers', labelKey: 'layers-blueprint', icon: 'layers', visible: !this.isUserSecundary },
      ];
    },

    alarmItems() {
      return [
        { to: '/recipient', labelKey: 'recipients', icon: 'mail', visible: !this.isUserSecundary },
        { to: '/recipientGroup', labelKey: 'teams', icon: 'groups', visible: !this.isUserSecundary },
        { to: '/schedule', labelKey: 'schedules', icon: 'calendar_month', visible: !this.isUserSecundary },
        { to: '/action', labelKey: 'actions', icon: 'bolt', visible: !this.isUserSecundary },
        { to: '/alarm', labelKey: 'alarms', icon: 'notification_settings', visible: !this.isUserSecundary },
      ];
    },

    videoItems() {
      return [
        { to: '/mosaic', labelKey: 'mosaic', icon: 'grid_on', visible: !this.isUserSecundary },
        { to: '/recordRecover', labelKey: 'record', icon: 'movie', visible: !this.isUserSecundary },
      ];
    },
  },
  methods: {
    onNavigate() {
      // close sidebar after a selection (esp. mobile)
      this.open = false;
    },
  },
  async created() {

    if (!this.dashboardStore.routes?.length) {
      this.dashboardService = new this.$dashboardService();
      this.dashboardService.listByPagination(0, 1000000)
        .then(data => {
          let dashboards = data.filter(d => d.enable);
          this.dashboardStore.setRoutes(dashboards);
        })
    }
  },
};
</script>

<style scoped>
/* keep your inner layout width & padding like before */
.sb-root {
  width: 15rem;
  padding-right: .5rem;
}
</style>